import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { NO_VALUE } from '../dash/dash.pipe';

@Pipe({
  name: 'secondsTimeFormatter',
})
export class SecondsTimeFormatter implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(seconds: number, datePipeFormat: string): unknown {
    if (seconds === null || seconds === undefined) {
      return NO_VALUE;
    }

    const dateRange = new Date(1970, 0, 1).setSeconds(seconds);

    return this.datePipe.transform(dateRange, datePipeFormat);
  }
}
